// Shared toast-message helper for the MM stores' mutation catch blocks.
//
// The backend now maps raw MSSQL failures to clean, field-named Feathers
// errors (see the API repo's src/hooks/describe-database-error.ts), e.g.
// "markNumber is required", "already exists", 'the database is missing
// "scheduledPourDate" — a migration has not been applied'. Surface that
// message in the error toast when it looks safe to show a user; otherwise
// keep the store's existing generic fallback.

// A toast should stay a single short line.
const MAX_MESSAGE_LENGTH = 140;

// SQL-ish leakage guard: if a raw statement fragment ever slips through
// (or the message carries a newline/stack), show the generic fallback.
const SQLISH = /select |update |insert |delete |exec /i;

export const mmErrorMessage = (error: unknown, fallback: string): string => {
  if (!(error instanceof Error)) return fallback;
  const message = error.message.trim();
  if (!message || message.length > MAX_MESSAGE_LENGTH) return fallback;
  if (message.includes("\n") || SQLISH.test(message)) return fallback;
  return message;
};
